/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NaturalPersonDTO } from './natural-person-dto';
import { LegalFormEnumDTO } from './legal-form-enum-dto';
import { AddressDataDTO } from './address-data-dto';


/**
 * Defines an organization with associated business premises
 */
export interface OrganizationUpdateBodyDTO { 
    /**
     * Represents an external id of the organization
     */
    organizationIdentifier: string;
    /**
     * name or description for the organization
     */
    name: string;
    /**
     * Optional default tax number for all related business premises as assigned by the German tax authorities
     */
    taxNumber?: string;
    /**
     * Optional default VAT identification number (Umsatzsteuer-Identifikationsnummer) for all related business premises  The new pattern is going to be applied soon - ^[A-Z]{2}[a-zA-Z0-9\\+\\*]{0,198}$ 
     */
    vatId?: string;
    /**
     * Optional description of the entity
     */
    detailedDescription?: string;
    /**
     * optional identification number
     */
    identificationNumber?: string;
    /**
     * Optional business identification number (Wirtschafts-Identifikationsnummer, W-IdNr) is intended to summarize and clarify the commercial tax numbers, some of which were only valid for individual types of tax. The business identification number has been issued in stages since November 2024 ([official documentation](https://www.bzst.de/DE/Unternehmen/Identifikationsnummern/Wirtschafts-Identifikationsnummer/wirtschaftsidentifikationsnummer_node.html)). The business identification number replaces economic identification number since January 2025. AO §146a WIdNr 
     */
    businessIdentificationNumber?: string;
    /**
     * Define fiscal flag for the Organization, it should only be possible to create a new business premise for an organization if there is a fiscal entity flag set to true
     */
    taxableEntity: boolean;
    legalForm?: LegalFormEnumDTO;
    /**
     * Represents the internal id of the organization parent id, should be null for root level organization
     */
    parentOrgId?: string;
    /**
     * Represents the internal id of the tenant. This property is only for DF admins.
     */
    tenantId?: string;
    addressData?: AddressDataDTO;
    naturalPerson?: NaturalPersonDTO;
    /**
     * Internet website address
     */
    website?: string;
}

export class ClsOrganizationUpdateBodyDTO { 
    /**
     * Represents an external id of the organization
     */
    organizationIdentifier: string = undefined;
    /**
     * name or description for the organization
     */
    name: string = undefined;
    /**
     * Optional default tax number for all related business premises as assigned by the German tax authorities
     */
    taxNumber?: string = undefined;
    /**
     * Optional default VAT identification number (Umsatzsteuer-Identifikationsnummer) for all related business premises  The new pattern is going to be applied soon - ^[A-Z]{2}[a-zA-Z0-9\\+\\*]{0,198}$ 
     */
    vatId?: string = undefined;
    /**
     * Optional description of the entity
     */
    detailedDescription?: string = undefined;
    /**
     * optional identification number
     */
    identificationNumber?: string = undefined;
    /**
     * Optional business identification number (Wirtschafts-Identifikationsnummer, W-IdNr) is intended to summarize and clarify the commercial tax numbers, some of which were only valid for individual types of tax. The business identification number has been issued in stages since November 2024 ([official documentation](https://www.bzst.de/DE/Unternehmen/Identifikationsnummern/Wirtschafts-Identifikationsnummer/wirtschaftsidentifikationsnummer_node.html)). The business identification number replaces economic identification number since January 2025. AO §146a WIdNr 
     */
    businessIdentificationNumber?: string = undefined;
    /**
     * Define fiscal flag for the Organization, it should only be possible to create a new business premise for an organization if there is a fiscal entity flag set to true
     */
    taxableEntity: boolean = undefined;
    legalForm?: LegalFormEnumDTO = undefined;
    /**
     * Represents the internal id of the organization parent id, should be null for root level organization
     */
    parentOrgId?: string = undefined;
    /**
     * Represents the internal id of the tenant. This property is only for DF admins.
     */
    tenantId?: string = undefined;
    addressData?: AddressDataDTO = undefined;
    naturalPerson?: NaturalPersonDTO = undefined;
    /**
     * Internet website address
     */
    website?: string = undefined;
}



